/** Central map: protected route path → required permission code.
 *  Audited in one place; consumed by nav.ts and the guarded route components. */
export const ROUTE_PERMISSIONS = {
  "/complaints": "workOrder:read:branch",
  "/escalations": "workOrder:read:branch",
  "/technicians": "vendor:read:organization",
  // "user:read:organization" does not exist; nearest code is "user:read:platform"
  "/admin": "user:read:platform",
  // HRMS user list + onboard (HRMS Auth Migration §8). The backend allows
  // EITHER user:read:platform (Super Admin) OR assignment:read:organization
  // (Organization Admin) via match:"any" — so gate the nav on the org-scoped
  // code, which company_administrator holds. super_admin still sees it (full
  // bypass); a platform-only /platform and /admin stay hidden from org admins.
  "/users": "assignment:read:organization",
  "/assets": "asset:read:organization",
  "/assets/list": "asset:read:organization",
  "/units/:id": "asset:read:organization",
  "/asset-verifications": "assetVerification:read:organization",
  "/asset-replacements": "assetReplacement:read:organization",
  "/verification-reports": "assetVerification:read:organization",
  "/inventory": "inventory:read:organization",
  "/properties": "property:read:organization",
  "/customers": "tenant:read:organization",
  "/config": "orgSettings:update:organization",
  "/reports": "report:read:organization",
  "/maintenance": "maintenanceSchedule:read:branch",
  "/platform": "organization:read:platform",
  "/collective-cases": "collectiveCase:read:organization",
  "/amc": "amc:read:organization",
  "/alerts": "notification:send:organization",
} as const;

export type ProtectedPath = keyof typeof ROUTE_PERMISSIONS;
